/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Table, Button, Space, Modal } from "antd"; // Import Table, Button, Space, Modal from Ant Design
import { ClientApi } from "../../services/ClientApi";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../contexts/AxiosProvider";
import { useSnackbar } from "notistack";

const { Column } = Table;

// DateConverter function
export const DateConverter = (dateString) => {
  const d = new Date(dateString);
  return d.toDateString();
};

export default function ClientTable() {
  const axios = useAxios();
  const [clientData, setClientData] = useState({
    clientList: [],
    totalClients: 0,
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [approveModalVisible, setApproveModalVisible] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    fetchAllClients();
  }, [page]);

  const fetchAllClients = async () => {
    try {
      setLoading(true);
      const data = {
        user_id: location.state.userId,
        search: false,
        searchParam: "",
        pageNumber: page,
        pageSize: rowsPerPage,
        status: "pending",
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleApprove = async () => {
    try {
      setLoading(true);
      const data = {
        client_id: selectedClient.client_id,
        status: "approved",
      };
      const response = await ClientApi.clientStatusChanged(axios, data);
      if (response.status === 200) {
        enqueueSnackbar("Client approved successfully !!", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        if (clientData.clientList.length === 1 && page > 1) {
          setPage((prevPage) => prevPage - 1);
        }
        fetchAllClients();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
      setApproveModalVisible(false);
    }
  };

  const handleReject = async () => {
    try {
      setLoading(true);
      const data = {
        client_id: selectedClient.client_id,
        status: "rejected",
      };
      const response = await ClientApi.clientStatusChanged(axios, data);
      if (response.status === 200) {
        enqueueSnackbar("Client rejected successfully !!", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        if (clientData.clientList.length === 1 && page > 1) {
          setPage((prevPage) => prevPage - 1);
        }
        fetchAllClients();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
      setRejectModalVisible(false);
    }
  };

  const handleApproveModal = (record) => {
    setSelectedClient(record);
    setApproveModalVisible(true);
  };

  const handleRejectModal = (record) => {
    setSelectedClient(record);
    setRejectModalVisible(true);
  };

  return (
    <>
      <Table
        dataSource={clientData.clientList}
        pagination={{
          total: clientData.totalClients,
          pageSize: rowsPerPage,
          current: page,
          onChange: handleChangePage,
        }}
      >
        <Column title="Function Name" dataIndex="domain_name" key="domain_name" />
        <Column title="Sub-Function Name" dataIndex="client_name" key="client_name" />
        <Column title="Created By" dataIndex="created_by" key="created_by" />
        <Column
          title="Created On"
          dataIndex="created_at"
          key="created_at"
          render={(created_at) => DateConverter(created_at)}
        />
        <Column
          title="Action"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <Button type="primary" onClick={() => handleApproveModal(record)}>
                Approve
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => handleRejectModal(record)}
              >
                Reject
              </Button>
            </Space>
          )}
        />
      </Table>

      {/* Approve Modal */}
      <Modal
        title="Approve Sub-Function"
        visible={approveModalVisible}
        onOk={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
      >
        <p>
          Are you sure you want to approve the Sub-Function "
          {selectedClient?.client_name}"?
        </p>
      </Modal>

      {/* Reject Modal */}
      <Modal
        title="Reject Sub-Function"
        visible={rejectModalVisible}
        onOk={handleReject}
        onCancel={() => setRejectModalVisible(false)}
      >
        <p>
          Are you sure you want to reject the Sub-Function "
          {selectedClient?.client_name}"?
        </p>
      </Modal>
    </>
  );
}
